var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "payment-plan-box" }, [
    _c("h3", { staticClass: "payment-heading" }, [_vm._v("Plan Details")]),
    _c("div", { staticClass: "payment-manage-area" }, [
      (_vm.isTrialPeriod && _vm.getCancelAt) || !_vm.subcription
        ? _c("ul", { staticClass: "payment-manager-list" }, [
            _vm._m(0),
            _vm._m(1),
          ])
        : _c("ul", { staticClass: "payment-manager-list" }, [
            _c("li", [
              _c(
                "strong",
                { staticClass: "payment-list-heading payment-green" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.totalEnterManagers >= 20 ? 20 : _vm.totalEnterManagers
                    ) +
                      "/" +
                      _vm._s(
                        _vm.subcription?.subscription_plan
                          ?.subscription_plan_access_permission
                          ?.managers_count >= 20
                          ? 20
                          : _vm.subcription?.subscription_plan
                              ?.subscription_plan_access_permission
                              ?.managers_count
                      ) +
                      " Managers added"
                  ),
                ]
              ),
              _c("span", { staticClass: "payment-list-text" }, [
                _vm._v(
                  " You can only add up to " +
                    _vm._s(
                      _vm.subcription?.subscription_plan
                        ?.subscription_plan_access_permission?.managers_count >=
                        20
                        ? 20
                        : _vm.subcription?.subscription_plan
                            ?.subscription_plan_access_permission
                            ?.managers_count
                    ) +
                    " Managers. Upgrade your subscription to add more. "
                ),
              ]),
            ]),
            _vm.subcribedAdditionalManagersPlan
              ? _c("li", [
                  _c(
                    "strong",
                    { staticClass: "payment-list-heading payment-green" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.totalEnterManagers >= 20
                            ? _vm.totalEnterManagers - 20
                            : 0
                        ) +
                          "/" +
                          _vm._s(
                            _vm.subcription?.subscription_plan
                              ?.subscription_plan_access_permission
                              ?.managers_count - 20
                          ) +
                          " Additional Managers added"
                      ),
                    ]
                  ),
                  _c("span", { staticClass: "payment-list-text" }, [
                    _vm._v(
                      " You can only add up to " +
                        _vm._s(
                          _vm.subcription?.subscription_plan
                            ?.subscription_plan_access_permission
                            ?.managers_count - 20
                        ) +
                        " Managers. Upgrade your subscription to add more. "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._m(2),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [
      _c("strong", { staticClass: "payment-list-heading" }, [
        _vm._v("0 Managers added"),
      ]),
      _c("span", { staticClass: "payment-list-text" }, [
        _vm._v(" Please upgrade your subscription to get started. "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [
      _c("strong", { staticClass: "payment-list-heading" }, [
        _vm._v("Unlimited Resource"),
      ]),
      _c("span", { staticClass: "payment-list-text" }, [
        _vm._v(
          " Add an unlimited amount of Resources to your company database. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [
      _c("strong", { staticClass: "payment-list-heading payment-green" }, [
        _vm._v("Unlimited Resources"),
      ]),
      _c("span", { staticClass: "payment-list-text" }, [
        _vm._v(
          " Add an unlimited amount of Resources to your company database. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }